import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from "react-router-dom";

import {
  AppBar,
  Grid,
  Button,
  Toolbar,
  Card,
  Typography,
  IconButton,
  CircularProgress,
  Menu,
  MenuItem,
  Box,
  Breadcrumbs,
  Link
} from '@mui/material';
import { isMobile } from 'react-device-detect';

import KPKUBImg from '../../assets/indonesiaharmoni.jpeg';
import { AccountCircle } from '@mui/icons-material';

import { API } from '../../config/API';
import { setUser } from '../../store/action';

import ModalEditProfil from '../Modal/ModalEditProfil';
import ModalUpdatePassword from '../Modal/ModalUpdatePassword';
import ModalSignout from '../Modal/ModalSignout';

function TopNav(props) {
  // console.log(process.env.REACT_APP_ROLLOUT_SSO)
  const navigate = useNavigate();
  const toSignin = () => process.env.REACT_APP_ROLLOUT_SSO === '1'
    ? window.open(`https://sso.kemenag.go.id?appid=${process.env.REACT_APP_KEMENAG_APP_ID}`)
    : navigate('/pwa/signin')
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openModalEditProfil, setOpenModalEditProfil] = useState(false);
  const [openModalUpdatePassword, setOpenModalUpdatePassword] = useState(false);
  const [openModalSignout, setOpenModalSignout] = useState(false);

  const whiteListRoute = ['/pwa/signin', '/pwa/signup', '/pwa/forget-password', '/maintenance', '/pwa/direct-signin']

  useEffect(() => {
    async function fetchUserProfile() {
      try {
        const token = Cookies.get('token_fkub')
        if (token) {
          let check = await API.get('/api/v1/user/check-token', { headers: { token: `Bearer ${token}` } })

          if (check) {
            let getInfoUser = await API.get(`/api/v1/user/profile/${check.data.data._id}`, { headers: { token: `Bearer ${token}` } })

            await props.setUser(getInfoUser.data.data)
          }
        }
      } catch (err) {
        props.setUser(null)
        Cookies.remove('token_fkub')
        navigate('/pwa')
      }
      setLoading(false)
    }

    fetchUserProfile()
    // eslint-disable-next-line
  }, [])


  const hideAppbar = useMemo(() => {
    if (whiteListRoute.includes(location.pathname)) {
      return true
    } else {
      return false
    }
    // eslint-disable-next-line
  }, [location])

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = (args) => {
    handleClose()

    if (args === 'editProfil') {
      setOpenModalEditProfil(true)
    } else if (args === 'updatePassword') {
      setOpenModalUpdatePassword(true)
    } else if (args === 'signout') {
      setOpenModalSignout(true)
    }
  }

  const routePage = useMemo(() => {
    const locationSplit = location.pathname.split('/')
    const Routes = [
      {
        pathname: '/pwa/news',
        title: 'Berita Kerukunan',
        breadcrumbTitle: ['Berita Kerukunan'],
        breadcrumbLink: [''],
      }, {
        pathname: '/pwa/referensi/*',
        pathSplit: ['referensi', ':id'],
        title: 'Detail Referensi',
        breadcrumbTitle: ['Referensi', 'Detail'],
        breadcrumbLink: ['/pwa/referensi'],
      }, {
        pathname: '/pwa/referensi',
        title: 'Referensi',
        breadcrumbTitle: ['Referensi'],
        breadcrumbLink: [''],
      }, {
        pathname: '/pwa/kutipan',
        title: 'Kutipan Kerukunan',
        breadcrumbTitle: ['Kutipan'],
        breadcrumbLink: [''],
      }, {
        pathname: '/pwa/regulasi',
        title: 'Regulasi',
        breadcrumbTitle: ['Regulasi'],
        breadcrumbLink: [''],
      }, {
        pathname: '/pwa/registration-fkub/edit/:id',
        pathSplit: ['registration-fkub', 'edit'],
        title: 'Registrasi FKUB',
        breadcrumbTitle: ['Perekaman FKUB', 'Registrasi'],
        breadcrumbLink: ['/pwa/registration-fkub'],
      }, {
        pathname: '/pwa/registration-fkub/form',
        pathSplit: ['registration-fkub', 'form'],
        title: 'Registrasi FKUB',
        breadcrumbTitle: ['Perekaman FKUB', 'Registrasi'],
        breadcrumbLink: ['/pwa/registration-fkub'],
      }, {
        pathname: '/pwa/registration-fkub/detail/:id',
        pathSplit: ['registration-fkub', 'detail'],
        title: 'Detail FKUB',
        breadcrumbTitle: ['Perekaman FKUB', 'Detail'],
        breadcrumbLink: ['/pwa/registration-fkub'],
      }, {
        pathname: '/pwa/registration-fkub',
        title: 'Perekaman FKUB',
        breadcrumbTitle: ['Perekaman FKUB']
      }, {
        pathname: '/pwa/fkub',
        title: 'FKUB',
        breadcrumbTitle: ['FKUB']
      }, {
        pathname: '/pwa/laporan-tusi/detail/:id',
        pathSplit: ['laporan-tusi', 'detail'],
        title: 'Laporan Tusi KUB',
        breadcrumbTitle: ['Laporan Tusi KUB', 'Detail'],
        breadcrumbLink: ['/pwa/laporan-tusi'],
      }, {
        pathname: '/pwa/laporan-tusi/edit/:id',
        pathSplit: ['laporan-tusi', 'edit'],
        title: 'Laporan Tusi KUB',
        breadcrumbTitle: ['Laporan Tusi KUB', 'Registrasi'],
        breadcrumbLink: ['/pwa/laporan-tusi'],
      }, {
        pathname: '/pwa/laporan-tusi/form',
        pathSplit: ['laporan-tusi', 'form'],
        title: 'Laporan Tusi KUB',
        breadcrumbTitle: ['Laporan Tusi KUB', 'Registrasi'],
        breadcrumbLink: ['/pwa/laporan-tusi'],
      }, {
        pathname: '/pwa/laporan-tusi',
        title: 'Laporan Tusi KUB',
        breadcrumbTitle: ['Laporan Tusi KUB']
      }, {
        pathname: '/pwa/rumah-ibadat/duplicate/:id/detail',
        pathSplit: ['rumah-ibadat', 'duplicate'],
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah', 'Detail'],
        breadcrumbLink: ['/pwa/rumah-ibadat'],
      }, {
        pathname: '/pwa/rumah-ibadat/duplicate/:id',
        pathSplit: ['rumah-ibadat', 'duplicate'],
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah', 'Detail'],
        breadcrumbLink: ['/pwa/rumah-ibadat'],
      }, {
        pathname: '/pwa/rumah-ibadat/detail/:id',
        pathSplit: ['rumah-ibadat', 'detail'],
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah', 'Detail'],
        breadcrumbLink: ['/pwa/rumah-ibadat'],
      }, {
        pathname: '/pwa/rumah-ibadat/edit/:id',
        pathSplit: ['rumah-ibadat', 'edit'],
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah', 'Registrasi'],
        breadcrumbLink: ['/pwa/rumah-ibadat'],
      }, {
        pathname: '/pwa/rumah-ibadat/form',
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah', 'Registrasi'],
        breadcrumbLink: ['/pwa/rumah-ibadat'],
      }, {
        pathname: '/pwa/rumah-ibadat',
        title: 'Registrasi Rumah Ibadah',
        breadcrumbTitle: ['Registrasi Rumah Ibadah']
      }, {
        pathname: '/pwa/akun',
        title: 'Akun Saya',
        breadcrumbTitle: ['Akun Saya']
      },
    ]

    let checkRoute = Routes.find(route =>
      route.pathname === location.pathname || (route.pathSplit && locationSplit[1] === route.pathSplit[0] && locationSplit[2] === route.pathSplit[1])
    )

    if (!!checkRoute) return checkRoute
    else return null

    // eslint-disable-next-line
  }, [location])

  return (
    <Grid sx={{ flexGrow: 1, display: hideAppbar ? 'none' : 'block' }}>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: 'white', zIndex: 50, maxWidth: '1440px', transform: 'translateX(-50%)',
          left: '50%',
        }}>
        <Toolbar
          style={{
            margin: '0px auto',
            justifyContent: 'space-between',
            width: '100%'
          }}
          sx={{ height: { xs: '73px', sm: '88px', md: '100px' }, maxWidth: { sm: 666, md: 1208 }, paddingX: 2 }} >
          <Grid style={{ display: 'flex', alignItems: 'center' }}>
            <Card
              sx={{ mr: { xs: 2, sm: 3 }, p: 0.5, borderRadius: 3, }}
            >
              <img
                src={KPKUBImg}
                alt='logo-kemenag'
                loading="lazy"
                width={isMobile ? 35 : 50}
                height={isMobile ? 35 : 50}
              />
            </Card>
            <Typography
              component="div"
              sx={{
                flexGrow: 1,
                maxWidth: 200,
                overflowWrap: 'break-word',
                textOverflow: 'text-clip',
                whiteSpace: 'normal',
                fontSize: { xs: '14px', sm: '20px' },
                fontWeight: 600,
                color: '#404040'
              }}
            >
              Pusat Kerukunan Umat Beragama
            </Typography>
          </Grid>

          {
            loading
              ? <CircularProgress style={{ color: "#9F0102", width: 36, height: 36 }} />
              : props.user_profile
                ? <>
                  <Box sx={{ display: 'flex', alignItems: 'center' }} >
                    <Box sx={{ mr: 1, display: { xs: 'none', sm: 'flex' }, flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center' }}>
                      {
                        props.user_profile?.name && <Typography sx={{ color: 'black', fontSize: 14, margin: 0 }}>{props.user_profile?.name}</Typography>
                      }
                      <Link sx={{ color: 'black', fontSize: 10, cursor: 'pointer' }} onClick={() => navigate('/pwa/akun')}>Akun saya</Link>
                    </Box>
                    <IconButton
                      size="medium"
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                      color="inherit"
                      aria-describedby={id}
                    >
                      <AccountCircle style={{ color: "black", width: 36, height: 36 }} />
                    </IconButton>
                  </Box>

                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}

                  >
                    <MenuItem style={{ width: '220px' }} onClick={() => {
                      handleClose()
                      navigate('/pwa/akun')
                    }}>Akun Saya</MenuItem>
                    <MenuItem onClick={() => handleOpenModal('editProfil')}>Ubah Akun</MenuItem>
                    <MenuItem onClick={() => handleOpenModal('updatePassword')}>Ubah Kata Sandi</MenuItem>
                    <MenuItem onClick={() => handleOpenModal('signout')}>Keluar</MenuItem>
                  </Menu>
                </>
                : <Button
                  className='button-primary'
                  sx={{
                    padding: { sm: '12px 16px 12px 16px' }
                  }}
                  onClick={toSignin}>
                  Masuk
                </Button>
          }
        </Toolbar>
      </AppBar>

      {
        !!routePage && <Box
          sx={{
            backgroundColor: '#F7F8FC',
            width: '100%',
            marginTop: { md: '100px', sm: '88px', xs: '73px' }
          }}>
          <Box
            style={{
              margin: '2px auto 0px',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
            sx={{ height: { xs: '71px', sm: '85px', md: '90px' }, maxWidth: { sm: 666, md: 1208 }, paddingX: 2 }}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
              <Typography color="inherit" sx={{ fontSize: { xs: '12px', sm: '14px' }, cursor: 'pointer' }} onClick={() => navigate('/pwa')}>Beranda</Typography>
              {
                routePage.breadcrumbTitle.map((title, index) =>
                  <Typography
                    key={`breadcrumb-${index}`}
                    color={index === routePage.breadcrumbTitle.length - 1 ? "text.primary" : "inherit"}
                    sx={{
                      fontSize: { xs: '12px', sm: '14px' },
                      cursor: index === routePage.breadcrumbTitle.length - 1 ? '' : 'pointer'
                    }}
                    onClick={() => index === routePage.breadcrumbTitle.length - 1 ? null : navigate(routePage.breadcrumbLink[index])}
                  >
                    {title}
                  </Typography>)
              }
            </Breadcrumbs>
            <Typography sx={{ fontSize: { xs: '20px', sm: '28px' } }}>{routePage.title}</Typography>
          </Box>
        </Box>

      }


      {
        openModalEditProfil && <ModalEditProfil
          open={openModalEditProfil}
          onClose={() => setOpenModalEditProfil(false)}
          userProfile={props.user_profile} />
      }

      {
        openModalUpdatePassword && <ModalUpdatePassword
          open={openModalUpdatePassword}
          onClose={() => setOpenModalUpdatePassword(false)}
          userProfile={props.user_profile} />
      }

      {
        openModalSignout && <ModalSignout
          open={openModalSignout}
          onClose={() => setOpenModalSignout(false)} />
      }
    </Grid >
  )
}


const mapDispatchToProps = {
  setUser
}

const mapStateToProps = ({ user_profile }) => {
  return {
    user_profile
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNav)
